<div class="rm-card">
  <h2 class="rm-heading">RISK MANAGEMENT</h2>

  <!-- Issues -->
  <div class="rm-section">
    <span class="rm-section-title">Issues</span>
    <div class="stat-row">
      <button type="button" class="stat-card stat-card--highlight tooltip-host clickable-tile"
        (click)="selectTotalIssues()">
        <span class="stat-num white">{{ totalIssues }}</span>
        <span class="stat-lbl white">Total Issues</span>
        <div class="tooltip-box">
          <strong class="tooltip-title">Issues Breakdown</strong>
          <span class="tooltip-line" *ngFor="let line of totalIssuesTooltipLines">{{ line }}</span>
        </div>
      </button>
      <button type="button" class="stat-card clickable-tile" *ngFor="let issue of issues"
        (click)="selectIssueStatus(issue.label)">
        <span class="stat-num purple">{{ issue.count }}</span>
        <span class="stat-lbl">{{ issue.label }}</span>
      </button>
    </div>
  </div>

  <!-- Issue Ratings -->
  <div class="rm-section">
    <span class="rm-section-title">Issue Ratings</span>
    <div class="rating-tiles">
      <button
        type="button"
        class="rating-tile clickable-tile"
        [class.rating-tile--dark]="rating.darkText"
        [style.background-color]="rating.color"
        *ngFor="let rating of issueRatings"
        (click)="selectIssueRating(rating.label)"
      >
        <span class="rating-num">{{ rating.count }}</span>
        <span class="rating-lbl">{{ rating.label }}</span>
      </button>
    </div>
  </div>

  <!-- Action Plans -->
  <div class="rm-section">
    <span class="rm-section-title">Action Plans</span>
    <div class="stat-row">
      <button type="button" class="stat-card stat-card--highlight clickable-tile"
        (click)="selectTotalActionPlans()">
        <span class="stat-num white">{{ totalActionPlans }}</span>
        <span class="stat-lbl white">Total</span>
      </button>
      <button type="button" class="stat-card clickable-tile" *ngFor="let plan of actionPlans"
        (click)="selectActionPlanStatus(plan.filterValue)">
        <span class="stat-num purple">{{ plan.count }}</span>
        <span class="stat-lbl">{{ plan.label }}</span>
      </button>
    </div>
  </div>
</div>
